import { getRequest, postRequest, getWorkorderID } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('WorkOrderID'))
    searchTerm = `${searchTerm}, WorkOrderID:${getWorkorderID()},`
  return getRequest(
    `workOrderStatusForm/get-list/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy ||
      '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`workOrderStatusForm/edit/${id}`)
}

export async function save(values) {
  return postRequest(`workOrderStatusForm/save`, values)
}

export function remove(values) {
  return postRequest(`workOrderStatusForm/delete`, values)
}
